(ns common.endpoints.bulk-edit.model
  "Shared transport contract for the bulk edit target asset summary endpoint.

   The bulk edit modal must know, for the selected entities, which of them have a
   target asset and the target asset type. On the new grid the selected rows are
   not in the session, so the modal loads this summary from the backend instead
   of reading the session.")

(def target-asset-attribute
  "The entity types whose bulk edit supports target asset editing, mapped to the
   ref attribute that holds the target asset. Both the frontend modal and the
   backend summary endpoint use this map, so the two stay consistent."
  {:entity.type/oppo     :oppo/target-asset
   :entity.type/investor :investor/legal-entity})

(def TargetAssetSummaryRequest
  [:map
   [:entity-type :keyword]
   [:entity-ids [:sequential :int]]])

(def TargetAssetSummaryResponse
  [:map
   [:target-assets
    [:map-of :int [:map
                   [:target-asset-id :int]
                   [:target-asset-type :keyword]]]]])
